import React from "react";
import "../../css/Inicio/calendario.css"; // O crea un CSS específico si lo prefieres

const CalendarioEventos = () => (
  <div className="calendario-eventos-bg">
    <div className="calendario-eventos-container">
      <h1>Calendario de Eventos</h1>
      <div className="calendario-eventos-iframe-wrapper">
        <iframe
          src="https://calendar.google.com/calendar/embed?src=calendariociudaddeoliva%40gmail.com&amp;ctz=America%2FArgentina%2FCordoba"
          style={{ border: 0 }}
          width="100%"
          height="700"
          title="Calendario de eventos"
        ></iframe>
      </div>
    </div>
  </div>
);

export default CalendarioEventos;